import React, { useRef, useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import { toast } from "react-toastify";
import SimpleMap from "../../../components/gmaps";
import Modal from "react-modal";
import moment from "moment";

const HubDetailForm = (props) => {
  const modalStyles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 10,
    },
    content: {
      backgroundColor: "#fff",
      padding: "20px",
      top: "10%",
      left: "25%",
      borderRadius: "5px",
      maxWidth: "700px",
      maxHeight: "auto",
      height: "500px",
      width: "100%",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
  };

  const { addForm, update } = props;
  const frmRef = useRef({});

  const [warehosuedata, setWarehosuedata] = useState([]);
  const [employeeId, setEmployeeId] = useState("");
  const [employeeData, setEmployeeData] = useState([]);
  const [warehosuelatLong, setWarehosuelatLong] = useState({
    lat: "",
    lng: "",
  });
  const [latLongclose, setLatLongclose] = useState(false);

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;
        setWarehosuelatLong({ lat, lng });
      },
      (error) => {
        console.error(error);
      }
    );
  }, []);

  const { sendRequest: getEmp } = useHttp();
  useEffect(() => {
    getEmp(
      {
        url: `/api/employee/?orgId=${localStorage.getItem("orgId")}`,
      },
      (data) => {
        setEmployeeData(data.output);
      }
    );
  }, [getEmp]);

  const handleLatLong = () => {
    setLatLongclose(true);
  };

  const { sendRequest: getWarehouseData } = useHttp();
  const getWarehouseDetail = () => {
    getWarehouseData({ url: "/api/warehouses/" }, (res) => {
      if (res) {
        setWarehosuedata(res);
      }
    });
  };

  useEffect(() => {
    getWarehouseDetail();
  }, [getWarehouseData]);

  const { sendRequest: postWarehouse } = useHttp();

  const submitHandler = (e) => {
    e.preventDefault();
    const data = {
      code: frmRef.current.code.value,
      name: frmRef.current.name.value,
      address: frmRef.current.warehouse_address.value,
      city: frmRef.current.city.value,
      state: frmRef.current.state.value,
      store_type_id:2,
      lga: frmRef.current.lga.value,
      country: frmRef.current.country.value,
      zipCode: frmRef.current.zipCode.value,
      latitude: warehosuelatLong.lat,
      longitude: warehosuelatLong.lng,
      SupervisorEmployeeId: employeeId,
      contactWork: frmRef.current.contactWork.value,
      whatsapp: frmRef.current.whatsapp.value,
      emailId: frmRef.current.emailId.value,
      orgId: parseInt(localStorage.getItem("orgId")),
      created_by: parseInt(localStorage.getItem("id")),
      serviceId: props.sId, 
      status:1,
    };

    if (props.update && props.update.id) {
      postWarehouse(
        {
          url: `/api/warehouses/${props.update.id}/`,
          method: "PUT",
          body: data,
        },
        () => {
          toast.success(`Warehouse detail updated`);
          props.addForm(false);
        }
      );
    } else {
      postWarehouse(
        {
          url: "/api/warehouses/",
          method: "POST",
          body: data,
        },
        () => {
          toast.success(`Warehouse detail added`);
          props.addForm(false);
        }
      );
    }
  };

  useEffect(() => {
    if (props.update) {
      if (frmRef.current.code) {
        frmRef.current.code.value = props.update.code || "";
      }
      if (frmRef.current.name) {
        frmRef.current.name.value = props.update.name || "";
      }
      if (frmRef.current.warehouse_address) {
        frmRef.current.warehouse_address.value = props.update.address || "";
      }
      if (frmRef.current.city) {
        frmRef.current.city.value = props.update.city || "";
      }
      if (frmRef.current.state) {
        frmRef.current.state.value = props.update.state || "";
      }
      if (frmRef.current.lga) {
        frmRef.current.lga.value = props.update.lga || "";
      }
      if (frmRef.current.country) {
        frmRef.current.country.value = props.update.country || "";
      }
      if (frmRef.current.zipCode) {
        frmRef.current.zipCode.value = props.update.zipCode || "";
      }
      if (frmRef.current.contactWork) {
        frmRef.current.contactWork.value = props.update.contactWork || "";
      }

      if (frmRef.current.whatsapp) {
        frmRef.current.whatsapp.value = props.update.whatsapp || "";
      }
      if (frmRef.current.emailId) {
        frmRef.current.emailId.value = props.update.emailId || "";
      }

      setEmployeeId(props.update.SupervisorEmployeeId || "");

      if (props.update.latitude && props.update.longitude) {
        setWarehosuelatLong({
          lat: props.update.latitude,
          lng: props.update.longitude,
        });
      }
    }
  }, [props.update]);

  return (
    <>
      {latLongclose && (
        <Modal onClose={setLatLongclose} isOpen={true} style={modalStyles}>
          <SimpleMap
            lat={warehosuelatLong.lat}
            lng={warehosuelatLong.lng}
            set={setWarehosuelatLong}
            close={setLatLongclose}
          />
        </Modal>
      )}{" "}
      <div className="content-wrapper">
        <div>&nbsp;</div>
        <section className="content">
          <form style={{ margin: "10px" }} onSubmit={submitHandler}>
            <div className="container-fluid">
              {/* SELECT2 EXAMPLE */}
              <div className="card card-default">
                <div className="card-header">
                  <h3 className="card-title">Hub Details</h3>
                  <div className="card-tools">
                    <button
                      type="button"
                      className="btn btn-tool"
                      data-card-widget="remove"
                      onClick={() => props.addForm(false)}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Hub Code</label>

                        <input
                          type="text"
                          className="form-control"
                          ref={(el) => (frmRef.current["code"] = el)}
                          autoComplete="off"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Hub Name </label>

                        <input
                          type="text"
                          className="form-control"
                          ref={(el) => (frmRef.current["name"] = el)}
                          autoComplete="off"
                          required
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Assigned Supervisor</label>
                        <select
                          id="SupervisorEmployeeId"
                          className="form-control"
                          ref={(el) => (frmRef.current["SupervisorEmployeeId"] = el)}
                          value={employeeId}
                          onChange={(e) => {
                            setEmployeeId(e.target.value);
                          }}
                          required
                        >
                          <option value="">Select Employee</option>
                          {employeeData &&
                            employeeData.map((x) => (
                              <option key={x.userId} value={x.userId}>
                                {x.employeeName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Hub Address</label>

                        <input
                          type="text"
                          className="form-control"
                          ref={(el) =>
                            (frmRef.current["warehouse_address"] = el)
                          }
                          autoComplete="off"
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>City </label>
                        <input
                          type="text"
                          id="city"
                          className="form-control"
                          ref={(el) => (frmRef.current["city"] = el)}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label> State/Province/Region</label>
                        <input
                          type="text"
                          id="state"
                          className="form-control"
                          ref={(el) => (frmRef.current["state"] = el)}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>LGA</label>
                        <input
                          type="text"
                          id="lga"
                          className="form-control"
                          ref={(el) => (frmRef.current["lga"] = el)}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Country </label>
                        <input
                          type="text"
                          id="country"
                          className="form-control"
                          ref={(el) => (frmRef.current["country"] = el)}
                          autoComplete="off"
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label>Zip Code (Postal Code) </label>
                        <input
                          type="text"
                          id="zip_code"
                          className="form-control"
                          ref={(el) => (frmRef.current["zipCode"] = el)}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label> Lat/Long</label>
                        <br />
                        <button
                          type={"button"}
                          id={"billinglatLong"}
                          autoComplete="off"
                          onClick={(e) => {
                            handleLatLong(e);
                          }}
                          ref={(el) => (frmRef.current["billinglatLong"] = el)}
                          className="btn btn-sm btn-warning"
                        >
                          Add
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group">
                        <label> Contact Number(Work)</label>
                        <input
                          type="text"
                          id="work"
                          className="form-control"
                          ref={(el) => (frmRef.current["contactWork"] = el)}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group">
                        <label> Contact Number(whatsapp)</label>
                        <input
                          type="text"
                          id="whatsapp"
                          className="form-control"
                          ref={(el) => (frmRef.current["whatsapp"] = el)}
                          autoComplete="off"
                        />
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="form-group">
                        <label> Email id</label>
                        <input
                          type="email"
                          id="emailId"
                          className="form-control"
                          ref={(el) => (frmRef.current["emailId"] = el)}
                          autoComplete="off"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4">
                      <div className="form-group"></div>
                    </div>
                    <div className="col-md-4">
                      <div className="form-group"></div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-4"></div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-1">
                      {" "}
                      <button
                        className="btn  btn-primary mx-2 my-2"
                        type="submit"
                      >
                        Add
                      </button>
                    </div>
                    <div className="col-md-1">
                      {/* <button className="btn  btn-primary mx-2 my-2" type="submit">
                Cancel
              </button> */}
                    </div>
                    <div className="col-md-1"> </div>
                    <div className="col-md-4"></div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default HubDetailForm;
